import { createFileRoute } from "@tanstack/react-router";
import { listQuestionnaires } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachQuestionnairesListPage } from "src/pages/CoachQuestionnairesListPage";

const routeSearchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_coach/questionnaires/")({
  component: CoachQuestionnairesListPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const questionnaires = await listQuestionnaires({
        query: { query: deps.q || undefined },
      }).then((response) => {
        return response.data.data;
      });

      return {
        data: {
          questionnaires: questionnaires,
        },
      };
    });
  },
});
